<template>
    <base-resource :booking_id="booking_id" :resource="resource" :headers="headers"
                   :element_list="form_content" :data-decoration="decor"/>
</template>
<script>
    import BaseResource from '../../../../components/base/Resource'
    import DateTimeHelper from "../../../../helpers/datetime";

    export default {
        name: "ContainerResource",
        props: ['booking_id'],
        components: {
            BaseResource
        },
        data: () => ({
            resource: 'container',
            headers: [
                { sortable: false, divider: true, align: 'start', text: 'Container', value: 'number' },
                { sortable: false, divider: true, align: 'start', text: 'Pickup Date', value: 'pickup_date' },
                { sortable: false, divider: true, align: 'start', text: 'Created At', value: 'created_at' },
                { sortable: false, divider: true, align: 'start', text: 'Created By', value: 'created_by' }
            ],
            form_content: [
                { md: '12', id: 'number', label: 'Container No', type: 'text-field', required: true },
                { md: '12', id: 'shipper_seal_number', label: 'Shipper Seal Number', type: 'text-field', required: true },
                { md: '12', id: 'customer_seal_number', label: 'Custom Seal Number', type: 'text-field', required: true },
                { md: '12', id: 'pickup_date', label: 'Pick Up Date', type: 'date-picker', required: true },
                { md: '12', id: 'remark', label: 'Remark', type: 'textarea', required: true }
            ],
            decor: (items = []) => {
                if(items.length == 0) {
                    return [];
                }
                items.forEach(x => x.created_at = DateTimeHelper.getDisplayDate(x.created_at));
            },
        })
    }
</script>